import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";

const buttonStyle = makeStyles(theme => ({
    button: {
        color: theme.palette.mode === "light" ? "#000000" : "#FFFFFF",
        fontWeight: 400,
        fontSize: 12,
        // fontFamily: "Inter",

        borderRadius: 8,
        borderColor: theme.palette.mode === "light" ? "#a4a4a4" : "#FFFFFF",
        margin: "0 2px",
        display: "flex",
        "&:hover": {
            backgroundColor: theme.palette.mode === "light" ? "#a4a4a4" : "#FFFFFF",
            color: theme.palette.mode === "light" ? "#000000" : "#000000",
            borderColor: theme.palette.mode === "light" ? "#a4a4a4" : "#FFFFFF",
            boxShadow: "none",
        },
        "&.error": {
            color: theme.palette.error.main,
            borderColor: theme.palette.error.main,
            "&:hover": {
                backgroundColor: theme.palette.error.dark,
                color: "white",

            },
            '&.Mui-disabled': {
                borderColor: theme.palette.mode === 'light' ? '#eaeaea' : '#b2b2b2',
                color: theme.palette.mode === 'light' ? '#c0c0c0' : '#b2b2b2',
            }
        },
        "&.primary": {
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: theme.palette.primary.main,
                color: "white",
            },
            '&.Mui-disabled': {
                borderColor: theme.palette.mode === 'light' ? '#eaeaea' : '#b2b2b2',
                color: theme.palette.mode === 'light' ? '#c0c0c0' : '#b2b2b2',
            }
        },
        "&.warning": {
            color: theme.palette.warning.contrastText,
            borderColor: theme.palette.warning.main,
            "&:hover": {
                backgroundColor: theme.palette.warning.main,
                color: theme.palette.warning.contrastText,
            },
            '&.Mui-disabled': {
                borderColor: theme.palette.mode === 'light' ? '#eaeaea' : '#b2b2b2',
                color: theme.palette.mode === 'light' ? '#c0c0c0' : '#b2b2b2',
            }
        },
        "&.small": {
            height: 30,
        },
        "&.medium": {
            height: 35,
        },
        "&.large": {
            height: 40,
        },
    },
    contained: {
        color: "#FFFFFF",
        "&:hover": {
            backgroundColor: theme.palette.primary.dark,
            color: "#FFFFFF",
        },
        "&.error": {
            color: "#FFFFFF",
            backgroundColor: theme.palette.error.main,
            "&:hover": {
                backgroundColor: theme.palette.mode === "light" ? theme.palette.error.light : theme.palette.error.dark,
            },
        },
        "&.warning": {
            color: theme.palette.warning.contrastText,
            backgroundColor: theme.palette.warning.main,
            "&:hover": {
                backgroundColor: theme.palette.mode === "light" ? theme.palette.warning.light : theme.palette.warning.dark,
            },
        },
        "&.grey": {
            color: theme.palette.mode === "light" ? "#000000" : "#FFFFFF",
            backgroundColor: theme.palette.background.paper,
            "&:hover": {
                backgroundColor: theme.palette.background.paperHover,
            },
        },
    },
    selected: {
        backgroundColor: theme.palette.mode === "light" ? "#BFC2C7" : "#FFFFFF",
        color: "#000000",
    },
    textTransform: {
        textTransform: "none",
    },
    font: {
        fontFamily: "Inter",
        fontWeight: 500,
        fontSize: 12,
    },
}));

const AgyleButton = (props) => {
    const classes = buttonStyle();

    // Style
    let sizeStyle = props.size;
    let isContained = props.variant === "contained";
    let isNonUpperCase = !props.upperCase;

    return (
        <Button
            name={props.name}
            variant={props.variant}
            className={clsx(
                classes.button, sizeStyle,
                isContained && classes.contained,
                props.colour,
                props.selected && classes.selected,
                isNonUpperCase && classes.textTransform,
                props.className
            )}
            fullWidth={props.fullWidth}
            onClick={props.onClick}
            startIcon={props.startIcon}
            endIcon={props.endIcon}
            disableTouchRipple={props.disableTouchRipple}
            disabled={props.disabled}
            disableElevation={!props.enableShadow}
            color={props.color}
            style={{
                width: props.width,
                justifyContent: props.justifyContent,
                ...props.style,
            }}
            onPointerMove={props.onPointerMove}
        >
            <div className={clsx(classes.font, props.fontClassName)}>
                {props.children}
            </div>
        </Button>
    );
};

export default AgyleButton;

AgyleButton.propTypes = {
    name: PropTypes.string,
    children: PropTypes.any,
    variant: PropTypes.oneOf(["contained", "outlined", "text"]),
    size: PropTypes.oneOf(["small", "medium", "large"]),
    onClick: PropTypes.func,
    startIcon: PropTypes.object,
    endIcon: PropTypes.object,
    disableTouchRipple: PropTypes.bool,
    disabled: PropTypes.bool,
    selected: PropTypes.bool,
    upperCase: PropTypes.bool,
    colour: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    justifyContent: PropTypes.oneOf(["flex-start", "center", "flex-end"]),
    style: PropTypes.object,
    enableShadow: PropTypes.bool,
    color: PropTypes.string,
    fullWidth: PropTypes.bool,
};

AgyleButton.defaultProps = {
    name: "",
    variant: "outlined",
    size: "medium",
    disableTouchRipple: false,
    disabled: false,
    selected: false,
    upperCase: false,
    fullWidth: false,
    colour: "info",
    width: "auto",
    justifyContent: "center",
    enableShadow: false
};